import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { LayoutDashboard, Package, Tags, Boxes, Sparkles, Users, Palette } from 'lucide-react';

const link = ({ isActive }) =>
  `flex items-center gap-2 rounded-lg px-3 py-2 text-sm font-medium transition-colors ${
    isActive
      ? 'bg-emerald-700 text-white'
      : 'text-slate-700 hover:bg-emerald-50 hover:text-emerald-800'
  }`;

const AdminLayout = () => {
  return (
    <div className="mx-auto max-w-7xl px-4 py-8 sm:px-6 lg:px-8">
      <h1 className="text-3xl font-bold tracking-tight text-slate-900">Panel de Administración</h1>
      <p className="mt-1 text-sm text-slate-600">Gestiona marcas, productos y categorías de tu catálogo.</p>

      <div className="mt-6 flex flex-col gap-6 md:flex-row">
        <aside className="md:w-60 md:shrink-0">
          <nav className="flex gap-2 overflow-x-auto md:flex-col md:gap-1">
            <NavLink to="/admin" end className={link}>
              <LayoutDashboard className="h-4 w-4" /> Resumen
            </NavLink>
            <NavLink to="/admin/marcas" className={link}>
              <Boxes className="h-4 w-4" /> Marcas
            </NavLink>
            <NavLink to="/admin/productos" className={link}>
              <Package className="h-4 w-4" /> Productos
            </NavLink>
            <NavLink to="/admin/categorias" className={link}>
              <Tags className="h-4 w-4" /> Categorías
            </NavLink>
            <NavLink to="/admin/cosmeticos" className={link}>
              <Palette className="h-4 w-4" /> Cosméticos
            </NavLink>
            <NavLink to="/admin/lo-nuevo" className={link}>
              <Sparkles className="h-4 w-4" /> Lo Nuevo
            </NavLink>
            <NavLink to="/admin/usuarios" className={link}>
              <Users className="h-4 w-4" /> Usuarios
            </NavLink>
          </nav>
        </aside>
        <main className="min-w-0 flex-1">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;
